import { AxiosInstance } from 'axios';

import { gameProfileEndpoints } from '../../utils/constants/endpoints';
import { axios } from '../axiosInstance';

import { GameProfile, UpdateGameProfileInput } from './GameProfileApi.schema';

class GameProfileApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getTopPlayers = async (): Promise<GameProfile[]> =>
    this.#requestInstance.get(gameProfileEndpoints.topPlayers);

  getUserProfile = async (userId: number): Promise<GameProfile> =>
    this.#requestInstance.get(gameProfileEndpoints.gameProfileId(userId));

  updateUserProfile = async (input: UpdateGameProfileInput): Promise<void> =>
    this.#requestInstance.patch(gameProfileEndpoints.gameProfileId(input.userId), input.body);
}

export const gameProfileApi = new GameProfileApi(axios);
